/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:90%;margin:0 auto;background-color:#fff!important;padding-top:100px;padding-bottom:100px}[_nghost-%COMP%]   .vimeo-player[_ngcontent-%COMP%]{width:100%;margin:3% auto;display:block}"];
export { styles as styles };
